import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useSession } from 'src/contexts/SessionContext';
import { fetchUser } from 'src/models/user/user';
import { getUserDisplayName } from 'src/models/user/utils';

export const TrainerCell = ({ id }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'common.labels' });
  const { user, sessionTrainer } = useSession();

  let isMe = user.id === id;

  if (!id) {
    isMe = user.id === sessionTrainer?.id;
  }

  const { data: fetchedUser, isLoading } = useQuery({
    queryKey: ['user', id],

    queryFn: async () => {
      return fetchUser({ id });
    },

    enabled: !isMe && !!id,
  });

  if (isMe) {
    return <>{t('Me')}</>;
  }

  const trainer = id ? fetchedUser : sessionTrainer;

  if (isLoading || !trainer) {
    return null;
  }

  return <>{getUserDisplayName(trainer, t('Unknown'))}</>;
};
